import { render } from "./StockSubmenu.vue?vue&type=template&id=41b69fd4"
import script from "./StockSubmenu.vue?vue&type=script&lang=js"
export * from "./StockSubmenu.vue?vue&type=script&lang=js"

import "./StockSubmenu.vue?vue&type=style&index=0&id=41b69fd4&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__